import dayjs from 'dayjs';

/** 배포 모달 로그와 동일: `HH:mm:ss` 접두 (dayjs 포맷) */
export function getWorkbenchLogTimePrefix(at: Date = new Date()): string {
  return dayjs(at).format('HH:mm:ss');
}

/** `[07:37:39] 메시지` 형식으로 비어 있지 않은 각 줄에 접두합니다. */
export function prefixWorkbenchLogBlock(raw: string, at: Date = new Date()): string {
  const ts = getWorkbenchLogTimePrefix(at);
  return raw
    .replace(/\r\n/g, '\n')
    .split('\n')
    .map((line) => (line.trim() === '' ? '' : `[${ts}] ${line}`))
    .join('\n');
}
